var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.9927C15.5228 19.9927 20 15.5185 20 9.9993C20 4.48007 15.5228 0.00585938 10 0.00585938C4.47715 0.00585938 0 4.48007 0 9.9993C0 15.5185 4.47715 19.9927 10 19.9927Z",
    fill: "#5BA1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19883 15.3155L4.4707 11.632L5.81508 9.90672L8.71852 12.1686L13.5104 5.25391L15.3085 6.49953L9.19883 15.3155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckBlue);
export default __webpack_public_path__ + "static/media/icon-check-blue.2af50886b545d1e0bbc31dff427c8a88.svg";
export { ForwardRef as ReactComponent };